// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__IDaqM","Label":"Input_Label__1Agqd","InputElement":"Input_InputElement__mB8I7","Invalid":"Input_Invalid__15_Ib"};